module.exports = __webpack_public_path__ + "img/12.aafe7e91.jpg";